@if (get(productOptionsRow, 'product_options.product', false)) {
  <section
    [ngStyle]="{
        'background-color': get(productOptionsRow.product_options, 'exxcom_color_picker', ''),
        'background-repeat': 'no-repeat',
        'margin-bottom': get(productOptionsRow.product_options, 'exxcom_color_picker', '').length > 0 ? '24px' : ''
    }"
    >
    <div class="container-gridless d-flex flex-row justify-content-center flex-wrap product-options">
      <div class="product-options-header col-12">
        <span class="tags text-center py-2 mb-1">{{ get(productOptionsRow, 'product_options.small_label', '') }}</span>
        <div class="category-top-title d-flex flex-row justify-content-center pb-2">
          @if (get(productOptionsRow, 'product_options.title', false)) {
            <h2 class="col-md-7 text-center">
              {{ productOptionsRow.product_options.title }}
            </h2>
          }
        </div>
      </div>
      @for (product of get(productOptionsRow, 'product_options.product', ''); track product) {
        <a
          class="d-flex flex-column flex-wrap align-items-center col-12 col-md-4 product-options-img-sect"
          [routerLink]="get(product, 'product_link.href', '')"
          >
          <img class="product-option-image" [src]="getWebpImg(get(product, 'product_image.href', ''))" [alt]="get(product, 'title', 'product')" />
          @if (get(product, 'title', false)) {
            <p class="product-option-title ml-2">
              {{ product.title }}
            </p>
          }
        </a>
      }
    </div>
    @if (!isEmpty(get(productOptionsRow, 'product_options.see_all_options', []))) {
      <div class="d-flex flex-row justify-content-center pt-2">
        <a role="button" class="button-primary" tabindex="0" (click)="openProductSpecDialog(null, productOptionsRow?.product_options?.see_all_options)" (keydown.enter)="openProductSpecDialog(null, productOptionsRow?.product_options?.see_all_options)">{{
          get(productOptionsRow, 'product_options.product_options_button_text', 'See all options')
        }}</a>
      </div>
    }
  </section>
}
@if (get(productOptionsRow, 'product_options.split_line', '')) {
  <hr class="m-0 mb-3" />
}
